import { ITheme } from "./interfaces";

export const defaultTheme: ITheme = {
  primary: "#4285F4",
  hover: "#f1f3f5",
  border: "#ccc",
  gray: "#aaa",
  background: "#fff",
  borderRadius: "4px",
  height: "38px"
};
